angular.module('auth')
    .service('Functionality', function($resource, BASE_PATH){
        return $resource(BASE_PATH.API_URL + 'groups/:groupId/functionalities/:idfunctionality', {
            groupId: '@groupId',
            idfunctionality: '@idfunctionality'
        });
    });
